// @flow
import React from 'react'
import ForArtists from '@pages/is/for-artists'

const ForArtistsPage = () => <ForArtists />

export default ForArtistsPage
